import { PageId } from 'constants/pages'

export const enum PageIdWoofzNpday70 {
  SUBSCRIPTIONS_NPDAY_70 = PageId.SUBSCRIPTIONS_NPDAY_70,
  CHAT_UPSELL_NPDAY_70 = PageId.CHAT_UPSELL_NPDAY_70,
  UPSELL_NPDAY_70 = PageId.UPSELL_NPDAY_70,
  DOWNLOAD_NPDAY_70 = PageId.DOWNLOAD_NPDAY_70,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
